import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BackOfficeLayout from "../../../components/backoffice-layout";
import InputSearchComponent from "../../../components/input-search";
import ButtonComponent from "../../../components/button";
import TableUserComponent from "../../../components/table-user";
import PaginatorComponent from "../../../components/paginator";
import IconPlus from "../../../assets/images/icon-plus-1.svg"
import { useNavigate } from "react-router-dom";
import CoreAPI from "../../../services/core";
import LoadingModal from "../../../components/loading-modal";
import DeleteModal from "../../../components/modal/delete";
import SuccessModal from "../../../components/modal/success";
import DropdownFilterComponent from "../../../components/evaluation-form-components/dropdown-filter";

const Container = styled.div`
    width: calc(100% - 32px);
    background-color: #FFFFFF;
    padding: 40px 16px;
    border-radius: 16px;

    .header-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;

        .header-label {
            width: fit-content;
            color: #25368D;
            font-size: 20px;
            font-weight: 600;
            line-height: 29.9px;
            text-align: left;
            padding: 2px;
            border-width: 0px 0px 3px 0px;
            border-style: solid;
            border-color: #25368D;
        }
    }


    .filter-bar {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 36px;

        .multi-box {
            display: flex;
            gap: 24px;

            .multi-select {
                width: calc(100% - 162px);
                display: flex;
                gap: 16px;

                .line {
                    width: 1px;
                    height: calc(100% - 16px);
                    margin-top: 20px;
                    background-color: #F2F2F2;
                }
            }
        }
    }

    .data-box {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
`;


function UserManagementPage() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [pageOption, setPageOption] = useState({
        limit: 10,
        page: 1,
        total_item: 0,
        total_page: 1,
    });
    const [orderOption, setOrderOption] = useState({
        order: "DESC",
        orderBy: "displayname",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const [dataFocus, setDataFocus] = useState(null);
    const [detailModal, setDetailModal] = useState({
        title: "",
        sub_title: "",
    });
    const [openModal, setOpenModal] = useState(false);
    const [detailSuccessModal, setDetailSuccessModal] = useState({
        title: "ลบสมาชิกสำเร็จ",
        sub_title: "",
        type: "success",
        button_label: "กลับหน้าหลัก",
    });
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [listDepartment, setListDepartment] = useState([]);
    const [listDivisionDefault, setListDivisionDefault] = useState([]);
    const [listDivision, setListDivision] = useState([]);
    const [listDepartmentSelect, setListDepartmentSelect] = useState([]);
    const [listDivisionSelect, setListDivisionSelect] = useState([]);


    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        setIsLoading(true);
        let _profile = localStorage.getItem("profile");
        try {
            _profile = JSON.parse(_profile)
        } catch { }
        if (_profile?.user_username !== "superadmin" && _profile?.user_username !== "admin") {
            navigate(`/account`);
            return
        }
        // if (_profile?.user_division_id) {
        //     navigate(`/account`);
        //     return
        // }
        let responseDepartment = [];
        let responseDivision = [];
        if (_profile) {
            if (_profile.user_department_id) {
                responseDepartment = await onGetDepartmentById(_profile.user_department_id)
            } else {
                responseDepartment = await onGetAllDepertment()
            }
            responseDivision = await onGetDivisionByDepertmentId(responseDepartment.map(x => x.id))
            setListDivisionDefault(JSON.parse(JSON.stringify(responseDivision)));
            setListDivision(JSON.parse(JSON.stringify(responseDivision)));
            setListDivisionSelect(JSON.parse(JSON.stringify(responseDivision)))
        }
        await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            responseDepartment.map(x => x.id),
            responseDivision.map(x => x.id),
        );
        setIsLoading(false);
    }
    async function onGetData(search, limit, page, order, order_by, department, division) {
        let response = null;
        try {
            const body = {
                search: search,
                search_by: ["firstname", "lastname", "username"],
                order: order || "ASC",
                order_by: order_by,
                limit: limit,
                page: page,
                department: [...department],
                division: [...division],
            };
            response = await CoreAPI.userHttpService.userGetByParam(body)
        } catch { }
        if (response) {
            let detailPage = { ...pageOption }
            detailPage.limit = response.limit;
            detailPage.page = response.page;
            detailPage.total_item = response.total_item;
            detailPage.total_page = response.total_page;
            setPageOption(detailPage);
            setListData(response.data)
        }
        return response;
    }
    async function onDeleteData(id) {
        let response = null;
        try {
            response = await CoreAPI.userHttpService.userDelete(id)
        } catch { }
        let detail = {
            title: "ลบสมาชิกล้มเหลว",
            sub_title: "",
            type: "fail",
            button_label: "กลับหน้าหลัก",
        }
        if (response) {
            if (response.success === true) {
                detail = {
                    title: "ลบสมาชิกสำเร็จ",
                    sub_title: "",
                    type: "success",
                    button_label: "กลับหน้าหลัก",
                }
            }
        }
        setOpenSuccessModal(true)
        setDetailSuccessModal(detail)
    }
    async function onUpdateStatus(param) {
        let response = null;
        try {
            let body = {
                user_id: param?.id,
                username: param?.username,
                firstname: param?.firstname,
                status: param?.status,
            }
            response = await CoreAPI.userHttpService.userUpdate(body)
        } catch { }
    }
    async function onGetDepartmentById(id) {
        let response = [];
        try {
            response = await CoreAPI.userHttpService.userGetDepertmentById(id)
        } catch { }
        if (response) {
            let list = [];
            const detail = {
                id: response.department_id,
                label: response.department_name,
            }
            list.push(detail);
            response = [...list]
        }
        setListDepartment(response)
        setListDepartmentSelect(JSON.parse(JSON.stringify(response)))
        return response;
    }
    async function onGetAllDepertment() {
        let response = null;
        try {
            response = await CoreAPI.userHttpService.userGetAllDepertment()
        } catch { }
        if (response) {
            let list = [];
            if (Array.isArray(response)) {
                list = JSON.parse(JSON.stringify(response));
                list = list.map(x => {
                    const detail = {
                        id: x.department_id,
                        label: x.department_name,
                    }
                    return detail
                })
            }
            response = [...list]
        }
        setListDepartment(response)
        setListDepartmentSelect(JSON.parse(JSON.stringify(response)))
        return response;
    }
    async function onGetDivisionByDepertmentId(list) {
        let response = [];
        try {
            const body = {
                list
            }
            response = await CoreAPI.userHttpService.userGetDivisionByDepertmentId(body)
        } catch { }
        if (response) {
            if (Array.isArray(response)) {
                response = response.map(x => {
                    const detail = {
                        id: x.division_id,
                        label: x.division_name,
                        department_id: x.department_id,
                    }
                    return detail
                })
            }
        }
        return response
    }

    async function handleInputSearch(param) {
        setSearch(param)
    }
    async function handleEnterSearch() {
        setIsLoading(true);
        await onGetData(
            search,
            pageOption.limit,
            1,
            orderOption.order,
            orderOption.orderBy,
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
        );
        setIsLoading(false);
    }
    async function handleChangePageOption(param) {
        setIsLoading(true);
        await onGetData(
            search,
            param.limit,
            param.page,
            orderOption.order,
            orderOption.orderBy,
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
        );
        setIsLoading(false);
    }
    async function handleChangeOrderOption(param) {
        setIsLoading(true);
        setOrderOption(param)
        await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            param.order,
            param.orderBy,
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
        );
        setIsLoading(false);
    }
    function handleCreate() {
        navigate('/user-management/create-update');
    }
    function handleUpdate(param) {
        const id = param.id;
        window.open(`${process.env.REACT_APP_BASE_PATH}/user-management/create-update/${id}`, '_blank');
        // navigate(`/user-management/create-update/${id}`);
    }
    async function handleChangeStatus(param) {
        setIsLoading(true);
        await onUpdateStatus(param);
        await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
        );
        setIsLoading(false);
    }
    function handleDelete(param) {
        let detail = { ...detailModal };
        detail.title = "ยืนยันการลบสมาชิก"
        detail.sub_title = param?.displayname
        setDetailModal(detail)
        setOpenModal(true)
        setDataFocus(param)
    }
    async function handleConfirmDelete() {
        let detail = { ...dataFocus }
        setOpenModal(false)
        setIsLoading(true);
        await onDeleteData(detail.id)
        const response = await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
        );
        if (response) {
            if (response.page !== 1 && response.data.length === 0) {
                await onGetData(
                    search,
                    pageOption.limit,
                    1,
                    orderOption.order,
                    orderOption.orderBy,
                    listDepartmentSelect.map(x => x.id),
                    listDivisionSelect.map(x => x.id),
                );
            }
        }
        setIsLoading(false);
        setDataFocus(null);
    }
    async function handleSelectDepartment(params) {
        setListDepartmentSelect(params)
        let list = JSON.parse(JSON.stringify(listDivisionDefault))
        let listSelect = JSON.parse(JSON.stringify(listDivisionSelect))
        listSelect = listSelect.filter(x => {
            const model = params.find(y => y.id === x.department_id);
            return model ? true : false;
        })
        list = list.filter(x => {
            const model = params.find(y => y.id === x.department_id);
            return model ? true : false;
        })
        setListDivision(list);
        setListDivisionSelect(listSelect);
    }
    async function handleSelectDivision(params) {
        setListDivisionSelect(params)
    }

    return (
        <BackOfficeLayout>
            <LoadingModal open={isLoading} />
            <DeleteModal
                open={openModal}
                onConfirm={handleConfirmDelete}
                onBack={(e) => setOpenModal(false)}
                title={detailModal.title}
                subTitle={detailModal.sub_title}
            />
            <SuccessModal
                open={openSuccessModal}
                onConfirm={(e) => setOpenSuccessModal(false)}
                title={detailSuccessModal.title}
                type={detailSuccessModal.type}
                buttonLabel={detailSuccessModal.button_label}
            />
            <Container>
                <div className="header-box vertical-center">
                    <div className="header-label">
                        รายชื่อสมาชิกทั้งหมด {pageOption.total_item !== 0 ? `(${pageOption.total_item})` : ""}
                    </div>
                    <ButtonComponent
                        label={"เพิ่มสมาชิกใหม่"}
                        variant={"primary"}
                        icon={IconPlus}
                        sceenSize={"lg"}
                        style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                        onClick={handleCreate}
                    />
                </div>
                <div className="filter-bar">
                    <InputSearchComponent
                        styleInput={{ height: "56px" }}
                        placeholder={"ค้นหา"}
                        onEnter={handleEnterSearch}
                        onInput={handleInputSearch}
                    />
                    <div className="multi-box">
                        <div className="multi-select">
                            <DropdownFilterComponent
                                label={"ฝ่าย"}
                                placeholder={"เลือกฝ่าย"}
                                list={listDepartment}
                                value={listDepartmentSelect}
                                mode={"multi"}
                                onSelect={handleSelectDepartment}
                            />
                            <div className="line"></div>
                            <DropdownFilterComponent
                                label={"กอง"}
                                placeholder={"เลือกกอง"}
                                list={listDivision}
                                value={listDivisionSelect}
                                mode={"multi"}
                                onSelect={handleSelectDivision}
                            />
                        </div>
                        <div className="vertical-center" style={{ paddingTop: "20px" }}>
                            <ButtonComponent
                                label={"ค้นหา"}
                                variant={"secondary"}
                                sceenSize={"lg"}
                                style={{ width: "156px", maxWidth: "156px", minWidth: "156px" }}
                                onClick={handleEnterSearch}
                            />
                        </div>
                    </div>
                </div>
                <div className="data-box">
                    <TableUserComponent
                        listData={listData}
                        order={orderOption}
                        onOrder={handleChangeOrderOption}
                        onDelete={handleDelete}
                        onUpdate={handleUpdate}
                        onChangeStatus={handleChangeStatus}
                    />
                    <PaginatorComponent
                        limit={pageOption.limit}
                        page={pageOption.page}
                        total_item={pageOption.total_item}
                        total_page={pageOption.total_page}
                        onChangePageOption={handleChangePageOption}
                    />
                </div>
            </Container>
        </BackOfficeLayout>
    )
}

export default UserManagementPage;